import { useState, useEffect } from "react";
import EnsightenAnalytics from "../Utility/EnsightenAnalytics";
import { postAuth } from "../Utility/API";
import { useSetRecoilState, useRecoilValue } from "recoil";
import { firstNameState, quotesState, successfulMatchState, staticAppConfig } from "../AppData/Recoil";
import { useNavigate } from "react-router-dom";
import OneXPageLoader from "../OneX/OneXPageLoader";

const Auth = () => {
  const [loading, setLoading] = useState(true);

  const setFirstName = useSetRecoilState(firstNameState);
  const setQuotesData = useSetRecoilState(quotesState);
  const setSuccesfulMatch = useSetRecoilState(successfulMatchState);
  const appConfig = useRecoilValue(staticAppConfig);

  const navigate = useNavigate();

  useEffect(() => {
    EnsightenAnalytics.pushScreenChangeToAnalytics("auth");

    const fetchData = async () => {
      try {
        // Fetch authentication data
        const res = await postAuth();
        if (!res) {
          throw new Error("Invalid response from server");
        }

        const { quotes, firstName } = res;

        // Update Recoil state
        setFirstName({ value: firstName, validationCode: -1 });
        setQuotesData(quotes);
        setSuccesfulMatch(true);

        // Push analytics data if there's a single quote
        if (quotes?.length === 1) {
          const productName = quotes[0].quoteProductLongName;
          if (productName) {
              EnsightenAnalytics.pushScreenChangeToAnalytics("single-quote", productName);

          } else {
          }
        }

        // Navigate based on quotes data
        if (quotes.length === 0) {
          navigate(appConfig.routes.noQuotes);
        } else if (quotes.length === 1) {
          window.location.assign(quotes[0].viewUrl);
        } else if (quotes.length > 1) {
          navigate(appConfig.routes.quotesList);
        } else {
          navigate(appConfig.routes.shapeError);
        }
      } catch (error) {
        navigate(appConfig.routes.shapeError);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Runs once when the component mounts

  // Show loader while processing
  if (loading) {
    return <OneXPageLoader />;
  }

  // No need to return anything else; navigation is handled inside the useEffect
  return null;
};

export default Auth;
